import React from "react";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import "./ExistingCheckIn.css";

const ExistingCausesList = ({ savedCauses, handleCauseDelete }) => {
  const { t } = useTranslation();

  if (!savedCauses || savedCauses.length === 0) {
    return null;
  }

  return (
    <div>
      <div>
        {/*
        <label className="duration-label">Existing causes</label>
        */}
      </div>
      <div className="select-component__duration-section">
        {savedCauses.map((option, idx) => (
          <button
            key={idx}
            className="strength-button select-component__duration-button two-part-button"
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              backgroundColor: "white",
            }}
            onClick={() => {}}
          >
            <span>
              {option.causeTypeTranslation?.[i18n.language] ||
                option.translation ||
                option.mood ||
                "No translation"}
            </span>

            <span
              className="right"
              onClick={(e) => {
                e.stopPropagation(); // critical: prevents main click
                handleCauseDelete(option); // delete action
              }}
            >
              X
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ExistingCausesList;
